import type { ReactNode } from 'react';
import { actionLabel, fieldLabel } from '../constants';
import { formatDateTime, formatRelative, historyValue } from '../format';
import type { HistoryEntry } from '../types';

/** Historien-Eintrag, optional mit Aufgabentitel (globale Historie). */
export interface HistoryListEntry extends HistoryEntry {
  taskTitle?: string | null;
}

/** Einzelner Historien-Eintrag. */
export function HistoryRow({ entry }: { entry: HistoryListEntry }): ReactNode {
  const field = fieldLabel(entry.field);
  const title = entry.taskTitle ?? null;
  return (
    <li className="history-row">
      <div className="history-row-head">
        <span className="history-action">{actionLabel(entry.action)}</span>
        {title !== null && title !== '' && <span className="history-task">{title}</span>}
        <time className="history-time" dateTime={new Date(entry.createdAt).toISOString()}>
          {formatDateTime(entry.createdAt)}
        </time>
      </div>
      <div className="history-row-body">
        <span className="history-actor">{entry.actorName}</span>
        {field !== null && (
          <span className="history-change">
            {field}: <span className="history-from">{historyValue(entry.fromValue)}</span>
            {' → '}
            <span className="history-to">{historyValue(entry.toValue)}</span>
          </span>
        )}
        {entry.note !== null && entry.note !== '' && <span className="history-note">{entry.note}</span>}
      </div>
      <div className="history-relative muted small">{formatRelative(entry.createdAt)}</div>
    </li>
  );
}

/** Liste von Historien-Einträgen (`compact` für das Detail-Panel). */
export function HistoryList({
  entries,
  compact = false,
}: {
  entries: HistoryListEntry[];
  compact?: boolean;
}): ReactNode {
  return (
    <ol className={compact ? 'history-list history-list-compact' : 'history-list'}>
      {entries.map((entry) => (
        <HistoryRow key={entry.id} entry={entry} />
      ))}
    </ol>
  );
}
